<template>
  <el-config-provider :locale="locale">
  <div id="app">
    <router-view></router-view>
  </div>
</el-config-provider>
</template>

<script>
// import setPartitonView from './components/SetPartitionDialog/setPartitonView.vue'
// import loginView from './components/LoginRegeisterView/loginView.vue'
//引入vue方法
import { ElConfigProvider } from 'element-plus'
import { onMounted } from 'vue';
//中文包
//import zhCn from 'element-plus/lib/locale/lang/zh-cn.js'

export default {
  name: 'App',
  components: {
    [ElConfigProvider.name]: ElConfigProvider

  },
  setup() {
    onMounted(() => {
      // 设置初始标题
      // document.title = '北京效立智能科技有限公司';
    });
    // let locale = zhCn
    // return {
    //   locale
    // }
  }
}
</script>


<style scoped>
* {
  padding: 0;
  margin: 0;
  outline: none;
  box-sizing: border-box;
  word-break: break-all;
  word-break: break-word;
}

html, body, #app {
  width: 100%;
  height: 100vh;
}
</style>
